import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box/Box';
import { Icon } from 'components/Icon/Icon';
import { Body } from 'components/Text/Body';
import { BodySmall } from 'components/Text/BodySmall';
import { colors } from 'theme/theme';
import { dateTime } from 'utils/date';
import { fileIdToUrl } from 'utils/s3file';

import { DeleteButton, FileLink, FilenameText } from './FilePicker.styled';

type Props = {
  fileId: string;
  large?: boolean;
  qaId: string;
  downloadAttachment?: boolean;
  filename: string | null | undefined;
  hideRemove?: boolean;
  onChange: (value: undefined) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types
  onError?: (arg0: Error) => void;
  created?: string;
  disabled?: boolean;
};

export function Filename({
  fileId,
  large,
  qaId,
  downloadAttachment,
  filename,
  hideRemove,
  onChange,
  created,
  disabled,
}: Props) {
  return (
    <div>
      <Box
        component={Body}
        position="relative"
        display="flex"
        alignItems="center"
        data-qa-id={`${qaId}-preview`}
      >
        <FileLink
          title={
            downloadAttachment
              ? getText('Download')
              : getText('Open in new window')
          }
          href={fileIdToUrl(fileId, downloadAttachment)}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation();
          }}
          rel="noopener noreferrer"
          $large={large}
        >
          <FilenameText $large={large}>{filename}</FilenameText>
        </FileLink>

        {!hideRemove && !disabled && (
          <Box ml={10}>
            <DeleteButton
              title={
                /* TRANSLATORS: Remove file upload */
                sprintf(getText('Remove file %(filename)s'), {
                  filename,
                })
              }
              data-qa-id={`${qaId}-delete`}
              onClick={(e) => {
                e.stopPropagation();
                onChange(undefined);
              }}
              $large={large}
            >
              <Icon name="close" size={16} />
            </DeleteButton>
          </Box>
        )}
      </Box>

      {created && (
        <Box width={1} flex="0 0 auto">
          <BodySmall
            color={colors.lightContentGrey}
            $whiteSpace="nowrap"
            lineHeight={1.25}
            data-qa-id={`${qaId}-upload-date`}
          >
            {sprintf(getText('Last updated: %(date)s'), {
              date: dateTime(created),
            })}
          </BodySmall>
        </Box>
      )}
    </div>
  );
}
